import React from 'react'

const Navbar = () => {
  return (
    <nav className='navbar'>
      <div className='flexbox-row' style={{ marginLeft: '12vw' }}>
        <div className='flexitem'>
          <a href='#intro' style={{ color: 'white' }}>
            {' '}
            About
          </a>
        </div>
        <div className='flexitem'>
          <a href='#skills' style={{ color: 'white' }}>
            {' '}
            Skills
          </a>
        </div>
        <div className='flexitem'>
          <a href='#interests' style={{ color: 'white' }}>
            {' '}
            Interests
          </a>
        </div>
        <div className='flexitem'>
          <a href='#letstalk' style={{ color: 'white' }}>
            {' '}
            Let's Talk
          </a>
        </div>
        <div className='flexitem decor' style={{ marginLeft: '22vw' }}>Radhika Mohta</div>

      </div>
    </nav>
  )
}

export default Navbar
